module.exports = __webpack_public_path__ + "img/g0208.8cbfc7db.png";